<div class="card shadow-sm">
  <div class="card-header">
    <h3 class="card-title">Details</h3>
  </div>
  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }
    <form [formGroup]="form">
      <div class="row g-3">
        <div class="col-12 mt-2">
          <input-field type="text" [inputFormControl]="getRequestSummaryInput()" label="Summary"
            placeholder="Summary" [readonly]="readonlyRequestDetails" />
        </div>
        <div class="col-12 mt-2">
          <textarea-field label="Description" placeholder="Write description here..."
            [textareaFormControl]="getRequestDescriptionInput()" [height]="250" [readonly]="readonlyRequestDetails"/>
        </div>
      </div>
    </form>
  </div>
</div>